import { Currency, TLD } from '@packages/common';

export const formattedPrice = (value: number, locale: TLD, currency = 'EUR'): string => {
  return value.toLocaleString(locale, {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};
